import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export const PROGRAM_INSTANCE_ONTOLOGY_ERRORS_KEY = 'program-instance-ontology-errors'

export type GetProgramInstanceOntologyErrorsRequest = {
  programInstanceId?: string
  startDate?: string
  endDate?: string
}

export type GetProgramInstanceOntologyErrorsResponse = {
  featureName: string
  accuracy: number
  accuracyTrend: number
  commonMistakes: string | null
}[]

export async function fetchProgramInstanceOntologyErrors({
  programInstanceId,
  startDate,
  endDate,
}: GetProgramInstanceOntologyErrorsRequest) {
  const response = await apiClient.get<GetProgramInstanceOntologyErrorsResponse>(
    `/int/v3/operators/program-instances/${programInstanceId}/ontology-errors/mine`,
    { params: { startDate, endDate } }
  )

  return response.data
}

export function useGetOntologyErrorsByProgramInstance({
  programInstanceId,
  startDate,
  endDate,
}: GetProgramInstanceOntologyErrorsRequest) {
  return useQuery({
    queryKey: [PROGRAM_INSTANCE_ONTOLOGY_ERRORS_KEY, programInstanceId, startDate, endDate],
    queryFn: () => fetchProgramInstanceOntologyErrors({ programInstanceId, startDate, endDate }),
    enabled: Boolean(programInstanceId) && Boolean(startDate) && Boolean(endDate),
    refetchOnWindowFocus: false,
  })
}
